var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessNewIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_34406_55314)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.9727 1.32812C42.3961 1.42442 42.9045 1.45723 43.2539 1.47754C43.7925 1.50884 44.1858 1.51982 44.4424 1.55176L44.4551 1.55371C46.029 1.73437 47.5905 2.01213 49.1299 2.38574L49.7881 2.55176C60.0078 5.2276 68.6966 11.9514 73.8506 21.1729V21.1738C75.8409 24.7567 77.2519 28.6297 78.0332 32.6494L78.1816 33.4561C78.3291 34.3852 78.4493 35.3186 78.543 36.2549V36.2559C78.5608 36.4426 78.5675 36.6765 78.5938 37.0605C78.6086 37.2786 78.6347 37.615 78.6963 37.918V42.0986C78.6359 42.3775 78.609 42.6655 78.5938 42.875C78.5782 43.0883 78.5576 43.5232 78.5518 43.6182C78.5249 44.0082 78.4876 44.3981 78.4404 44.7871C78.2381 46.4366 77.9294 48.0716 77.5166 49.6816C74.9084 59.7082 68.4042 68.2777 59.4492 73.4863L59.4463 73.4883C55.5417 75.7718 51.2617 77.3408 46.8066 78.124C46.1289 78.2368 45.4491 78.3365 44.7676 78.4219L44.082 78.5029C43.9163 78.5212 43.605 78.5424 43.1797 78.582C42.9891 78.5998 42.7866 78.621 42.6104 78.6445C42.5227 78.6562 42.4294 78.6697 42.3408 78.6865C42.328 78.689 42.3129 78.6928 42.2959 78.6963H37.8428C37.6739 78.655 37.5249 78.635 37.4355 78.625C37.256 78.6049 37.0688 78.5948 36.9883 78.5898C35.7296 78.5115 34.4953 78.3296 33.2002 78.1035C29.2031 77.3971 25.3428 76.0621 21.7637 74.1475C12.3212 69.0963 5.38805 60.3643 2.6084 50.0225C2.22628 48.5835 1.92339 47.1245 1.70117 45.6523L1.61133 45.0205C1.57619 44.7462 1.54779 44.2045 1.50098 43.5488C1.47916 43.2433 1.45381 42.9246 1.42188 42.6465C1.40335 42.4852 1.37479 42.2717 1.32812 42.0645V37.9717C1.40526 37.6428 1.41199 37.3425 1.41797 37.2441C1.49048 36.0533 1.60585 34.8886 1.80176 33.7402L1.80273 33.7324C2.53618 29.2775 4.04291 24.9848 6.25488 21.0488L6.25586 21.0479C11.3757 11.9067 19.9947 5.24134 30.1299 2.58594L30.1289 2.58496C31.8124 2.1487 33.5216 1.81876 35.2461 1.59375L35.2471 1.59277C35.6045 1.54603 35.9635 1.51059 36.3232 1.4873C36.4532 1.47961 36.8875 1.46277 37.1611 1.44336C37.3983 1.42654 37.7245 1.39646 38.0322 1.32812H41.9727Z",
    fill: "#3BC75B",
    stroke: "#549C64",
    strokeWidth: 2.65706
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M14.6914 21.4243C28.1959 11.2959 55.2047 14.672 65.333 21.4243V16.3601C55.2047 9.60785 28.1959 6.23174 14.6914 16.3601V21.4243Z",
    fill: "url(#paint0_linear_34406_55314)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M63.7219 50.2178C53.4349 63.6016 26.5118 67.6054 14.9419 63.8224L16.3023 68.7004C27.8723 72.4835 54.7953 68.4797 65.0824 55.0957L63.7219 50.2178Z",
    fill: "url(#paint1_linear_34406_55314)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8198 41.0054L34.9481 51.1338L55.2048 27.501",
    stroke: "white",
    strokeWidth: 6.75222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_34406_55314",
    x1: 14.6914,
    y1: 9.96776,
    x2: 65.333,
    y2: 9.96776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_34406_55314",
    x1: 84.28,
    y1: 53.492,
    x2: 18.0196,
    y2: 74.8577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_34406_55314"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80.0244,
    height: 80.0244,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessNewIcon);
export default __webpack_public_path__ + "static/media/successNewIcon.99ff5693a3fda013ea700213d92d7cff.svg";
export { ForwardRef as ReactComponent };